<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-subordinates`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 3a1 1 0 011 1v16a1 1 0 01-1 1h-8v15.5h16V28a1 1 0 011-1h16a1 1 0 011 1v16a1 1 0 01-1 1H29a1 1 0 01-1-1v-3.5H8V21H4a1 1 0 01-1-1V4a1 1 0 011-1h16zm22 28H32v10h10V31zM7 7h10v10H7V7z"/></svg>
</template>
<script>

export default {
  name: 'IconSubordinates',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
